import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { Driver } from '../types/entities/Driver';

export const driver: SchemaWithClient<Driver> = {
  name: 'Driver',
  pluralName: 'Driver',
  columns: {
    name: {
      name: 'Name',
      required: true,
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    phone: {
      name: 'Phone',
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    notes: {
      name: 'Notes',
      fieldRenderer: TextField,
      fieldType: 'textarea',
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/drivers'),
};
